// extracted by mini-css-extract-plugin
export default {"frame":"Frame_frame__nLtdS","frameMain":"Frame_frameMain__e15oV","frameMainIsCollapsed":"Frame_frameMainIsCollapsed__v+AJo","content":"Frame_content__8N31d"};